export const ASYNC_SELECT_LOCAL_PAGE_SIZE = 50
